/**
 * Represents an error that occurs when there is a version mismatch between incoming event and current order-store.
 */
class VersionMismatchError extends Error {
    constructor(public readonly message: string) {
        super(message);
        this.name = "VersionMismatchError";
    }
}

const isVersionMismatchError = (
    error: unknown
): error is VersionMismatchError => {
    return error instanceof VersionMismatchError;
};

export { VersionMismatchError, isVersionMismatchError };
